export const extractValue = val => {
  const unit = extractUnit(val);
  if (unit === null) {
    return val;
  }
  return val.replace(unit, '');
};
export const extractUnit = val => {
  if (val.includes('px')) {
    return 'px';
  } else if (val.includes('%')) {
    return '%';
  }
  return null;
};

// Get coordinates of element from body
export const getElementAbsoluteCoords = elem => {
  // crossbrowser version
  if (!elem) return {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  };
  const box = elem.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  const width = box.width;
  const height = box.height;
  return {
    top: Math.round(top),
    left: Math.round(left),
    width,
    height
  };
};
export default {
  extractValue,
  extractUnit,
  getElementAbsoluteCoords
};